import { useState } from 'react';

const faqs = [
  {
    question: '부산호스트바 추천을 받으려면 어디로 문의하나요?',
    answer: '전화 010-5781-5340 또는 홈페이지 문의 폼을 통해 24시간 상담 가능합니다. 고객님의 취향에 맞는 최적의 부산 호스트바를 추천해드립니다.',
  },
  {
    question: '부산 호스트클럽 예약은 어떻게 하나요?',
    answer: '전화(010-5781-5340) 또는 문자 메시지로 24시간 예약 가능합니다. 홈페이지 문의 폼을 통해서도 예약 문의를 남기실 수 있으며, 빠른 시간 안에 답변드립니다.',
  },
  {
    question: '서면 호스트바 지점 위치가 어디인가요?',
    answer: '서면지점은 부산광역시 부산진구 신천대로62번길 67에 위치합니다. 1·2호선 서면역 1번 출구에서 도보 3분 거리이며, 전용 주차장도 운영합니다.',
  },
  {
    question: '해운대 호스트바 지점도 있나요?',
    answer: '네, 해운대구 구남로 37에 해운대지점을 운영 중입니다. 2호선 해운대역 3번 출구에서 도보 5분 거리입니다. 해운대 바다뷰와 함께 특별한 분위기를 즐기실 수 있습니다.',
  },
  {
    question: '부산호스트바 VIP 서비스는 어떻게 이용하나요?',
    answer: 'VIP 서비스는 최고급 프라이빗 룸에서 전담 호스트와 함께하는 프리미엄 패키지입니다. 사전 예약 시 고객님만을 위한 맞춤 서비스를 제공합니다. 전화로 문의 주시면 자세히 안내해드립니다.',
  },
  {
    question: '부산호스트바 운영 시간은 어떻게 되나요?',
    answer: '서면·해운대·광안리·연산동 4개 모든 지점이 매일 24시간 연중무휴로 운영됩니다. 언제든 편하신 시간에 방문하거나 예약하실 수 있습니다.',
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section id="faq" className="py-20 md:py-32 bg-black relative overflow-hidden">
      <div
        className="absolute top-0 left-1/2 -translate-x-1/2 w-[600px] h-[300px] pointer-events-none opacity-5"
        style={{ background: 'radial-gradient(ellipse, #06b6d4 0%, transparent 70%)', filter: 'blur(80px)' }}
      />

      <div className="max-w-4xl mx-auto px-6 md:px-8 relative z-10">
        <div className="text-center mb-12 md:mb-16">
          <div
            className="inline-block px-6 py-2 rounded-full mb-6 md:mb-8 border"
            style={{ borderColor: '#06b6d4', boxShadow: '0 0 12px rgba(6,182,212,0.3)' }}
          >
            <span
              className="text-sm font-medium tracking-wider"
              style={{ color: '#06b6d4', textShadow: '0 0 8px #06b6d4' }}
            >
              FAQ
            </span>
          </div>
          <h2
            className="text-3xl md:text-5xl font-bold mb-4 leading-tight"
            style={{ fontFamily: "'Orbitron', sans-serif", color: '#fff', textShadow: '0 0 15px rgba(255,255,255,0.15)' }}
          >
            자주 묻는
            <span style={{ color: '#ec4899', textShadow: '0 0 15px #ec4899' }}> 질문</span>
          </h2>
          <p className="text-gray-400 text-sm leading-relaxed">
            부산호스트바 추천 및 이용에 관한 궁금한 점을 정리했습니다.
          </p>
        </div>

        <div
          className="w-full h-px mb-10 md:mb-12"
          style={{ background: 'linear-gradient(90deg, transparent, #06b6d4, #ec4899, transparent)' }}
        />

        <div className="space-y-3 md:space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl border border-gray-800 overflow-hidden transition-all duration-300 cursor-pointer"
              style={{
                background: 'rgba(255,255,255,0.02)',
                borderColor: openIndex === index ? '#ec4899' : '#1f2937',
                boxShadow: openIndex === index ? '0 0 20px rgba(236,72,153,0.15)' : 'none',
              }}
              onClick={() => toggle(index)}
            >
              <div className="flex items-center justify-between px-5 md:px-6 py-4 md:py-5 gap-4">
                <h4 className="text-sm md:text-base font-semibold text-white leading-snug flex-1 pr-2">
                  <a className="hover:no-underline">{faq.question}</a>
                </h4>
                <div
                  className="w-7 h-7 flex items-center justify-center flex-shrink-0 rounded-full transition-all duration-300"
                  style={{
                    background: openIndex === index ? 'rgba(236,72,153,0.15)' : 'rgba(255,255,255,0.05)',
                    border: `1px solid ${openIndex === index ? '#ec4899' : '#374151'}`,
                  }}
                >
                  <i
                    className={`ri-${openIndex === index ? 'subtract' : 'add'}-line text-sm`}
                    style={{ color: openIndex === index ? '#ec4899' : '#6b7280' }}
                  />
                </div>
              </div>

              {openIndex === index && (
                <div
                  className="px-5 md:px-6 pb-5 md:pb-6"
                  style={{ borderTop: '1px solid rgba(236,72,153,0.2)' }}
                >
                  <p className="text-gray-400 text-sm leading-relaxed pt-4">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 md:mt-14 text-center">
          <p className="text-gray-500 text-sm mb-4">더 궁금한 점이 있으신가요?</p>
          <a
            href="tel:01057815340"
            className="inline-flex items-center gap-3 px-8 py-3 rounded-full font-semibold text-black transition-all whitespace-nowrap cursor-pointer"
            style={{ background: 'linear-gradient(135deg, #ec4899, #f97316)', boxShadow: '0 0 20px rgba(236,72,153,0.4)' }}
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-phone-fill text-base" />
            </div>
            010-5781-5340 바로 통화
          </a>
        </div>
      </div>
    </section>
  );
}
